import { useNavigate } from "react-router-dom";

import PageNotFoundImage from "@/assets/svg/pageNotFound.svg?react";
import { Button } from "@/components/ui/button";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-teal-50 p-8">
      <div className="shrink-0">
        <PageNotFoundImage className="flex-1" />
      </div>
      <p className="text-2xl text-center font-bold text-txtHeading mt-10">
        The link appears to be invalid.
      </p>
      <p className="text-2xl text-center font-bold text-txtHeading">
        Please review the link or log in to continue.
      </p>
      <Button
        className="py-3 px-8 my-9 text-base font-semibold rounded-xl"
        variant="outline"
        onClick={() => {
          navigate("/login");
        }}
      >
        Go to login page
      </Button>
    </div>
  );
};

export default NotFoundPage;
